import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { Channel } from 'stream-chat';
import { OrAvatarComponent, OrIconComponent } from '@ui-components';
import { HighlightMatchPipe } from '@core';
import { ChannelListItemViewService } from './view-service/channel-list-item.view-service';

@Component({
  selector: 'lib-channel-list-item',
  templateUrl: './channel-list-item.component.html',
  styleUrls: ['./channel-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrAvatarComponent, HighlightMatchPipe, OrIconComponent],
  providers: [ChannelListItemViewService]
})
export class ChannelListItemComponent {
  private readonly viewService: ChannelListItemViewService = inject(ChannelListItemViewService);

  readonly channel: InputSignal<Channel> = input.required<Channel>();
  readonly highlightQuery: InputSignal<string> = input<string>('');
  readonly refreshTick: InputSignal<number> = input<number>(0);

  readonly channelTypeIcon: Signal<string | null> = computed(() => this.viewService.getChannelTypeIcon(this.channel()));

  readonly channelName: Signal<string> = computed(() => {
    this.refreshTick();
    return this.viewService.getChannelName(this.channel());
  });

  readonly channelImage: Signal<string | null> = computed(() => {
    this.refreshTick();
    return this.viewService.getChannelImage(this.channel());
  });

  readonly lastMessage: Signal<string> = computed(() => {
    this.refreshTick();
    return this.viewService.getLastMessage(this.channel());
  });

  readonly lastMessageTime: Signal<string> = computed(() => {
    this.refreshTick();
    return this.viewService.getLastMessageTime(this.channel());
  });

  readonly unreadCount: Signal<number> = computed(() => {
    this.refreshTick();
    return this.viewService.getUnreadCount(this.channel());
  });

  readonly isMuted: Signal<boolean> = computed(() => {
    this.refreshTick();
    return this.viewService.isMuted(this.channel());
  });
}
